import { createContext, useContext } from "react";
import { IDeleteTeamContext, IDeleteTeamEligibilityContext } from "./type";

const DeleteTeamContext = createContext<IDeleteTeamContext>(null);
const DeleteTeamEligibilityContext = createContext<IDeleteTeamEligibilityContext>(null);

export const useDeleteTeamContext = () => useContext(DeleteTeamContext);
export const useDeleteTeamEligibilityContext = () => useContext(DeleteTeamEligibilityContext);
export { DeleteTeamContext, DeleteTeamEligibilityContext };
